module.exports = __webpack_public_path__ + "img/moses-rogers.1cf62c38.png";